import { AVAILABLE_IMAGE_WIDTH, MAX_IMAGE_WIDTH } from 'widget/constants/image-sizes';

const isGif = coverUrl => /.gif$/.test(coverUrl);
const round100 = (width, height) => Math.round((width / height) * 100) / 100;

const cache = {};

export function getNormalizedCachedDimensions(coverUrl, { containerWidth, containerHeight }) {
  const aspectRatio = round100(containerWidth, containerHeight);
  const cachedSizes = _.get(cache[aspectRatio], [coverUrl]);

  const loadedImageWidth = _.get(cachedSizes, 'width', 0);
  const loadedImageHeight = _.get(cachedSizes, 'height', 0);

  const widthCandidate = _.find(AVAILABLE_IMAGE_WIDTH, size => size >= containerWidth);
  const width = isGif(coverUrl) ? MAX_IMAGE_WIDTH : Math.max(widthCandidate, loadedImageWidth);

  const heightCandidate = Math.round(width / aspectRatio);
  const height = Math.max(heightCandidate, loadedImageHeight);

  if (!cache[aspectRatio]) {
    cache[aspectRatio] = {};
  }

  cache[aspectRatio][coverUrl] = { width, height };

  return [width, height];
}



// WEBPACK FOOTER //
// ./src/widget/utils/normalize-image-dimensions.js